import React, { useState } from 'react';
import '../styles/OurTeam.css';
import jenPhoto from '../assets/Jen.jpg';
import simonPhoto from '../assets/Simon.jpg';
import ProfileModal from '../components/OurTeam/ProfileModal';
import claudiaPhoto from '../assets/claudia.png';
import jenLogo from '../assets/Whoweare/SIEA_Logo.jpeg';

function OurTeam() {
  const [selectedProfile, setSelectedProfile] = useState(null);

  const teamMembers = [
    {
      id: 'simon',
      name: 'Simon Yio',
      title: 'Senior Consultant',
      modalTitle: 'Business Owner & Coach | Asset Progression Strategist',
      photo: simonPhoto,
      hasModal: true,
      description: `Simon Yio is a prominent figure in Singapore's real estate industry, renowned for his strategic leadership, deep industry connections, and visionary approach. With over 27 years of experience, Simon has driven growth and innovation at some of the country's leading real estate firms. His career includes serving as the Chief Operating Officer of one of Singapore's top four real estate companies, where he led the firm through critical growth phases, and as Managing Director of a local geospatial technology firm, where he spearheaded a public-private partnership with the Ministry of National Development to develop a crisis portal during a challenging period.

Simon's success is defined by his ability to forge lasting relationships and leverage his vast network to create opportunities. His strong ties with local developers have enabled him to collaborate closely with agent leaders, helping shape and implement effective sales and marketing strategies for residential and commercial projects, and securing key developments in a competitive market.

Before transitioning to corporate leadership in 2011, Simon was an award-winning agency leader, earning accolades such as the IEA Realtor Awards, PropNex Top Individual Sales and Top Leader Awards, and OrangeTee Top Leader Awards from 2009 to 2010. Consistently ranked among the industry's top producers, Simon earned the trust and respect of peers and clients.

Simon's global investment experience spans a wide array of property types, from private residential and industrial to high-capital market investments. He has advised a property investment firm on capital market properties and guided a PropTech company through public-private partnerships. Simon's international ventures also include property transactions in Australia and Cambodia.

With his unparalleled expertise, strong industry connections, and unwavering commitment to excellence, Simon continues to shape the future of real estate, offering invaluable insight and guidance to clients, developers, and businesses alike.`
    },
    {
      id: 'jen',
      name: 'Jen Lee',
      title: 'Senior Marketing Director',
      modalTitle: 'Business Owner | Asset Progression Strategist',
      photo: jenPhoto,
      logo: jenLogo,
      hasModal: true,
      description: `With a distinguished career built on purposeful strategies and unparalleled dedication, Jen Lee is redefining real estate excellence for families, young professionals, and high-net-worth individuals. As the Marketing Director and owner of a thriving co-living business, Jen seamlessly blends innovation with personalized service, delivering transformative results in Singapore's competitive property landscape.

Record-Breaking Achievements:
• Sold a resale condominium in January 2024, earning both ERA Superstar Achiever and ERA Top 100 Achievers accolades in February 2024.
• Achieved record-breaking sales for a 4-room HDB in Ghim Moh (June 2024) and Cambridge Road (November 2024).
• Set a new benchmark for a privatized HUDC property sale in January 2025.

Award-Winning Excellence:
• Founder of Rentable Pte Ltd, a local coliving and property management company
• Attained record-breaking sales in both HDB and private segments in 2024 and 2025
• ERA Top 100 Achievers in Feb 2024
• Ranked Top 20% Achievers in Year 2024
• Ranked among Top 10% of agents at Group Level in 2024
• Ranked among Top 5% of agents at Advisory Level in 2024
• ERA Million Dollar Club member
• Consistent 5-star Realtor on PropertyGuru
• Awardee of SIEA's Rookies Award & Salespersons Achievement Award (Platinum) 2025

Unmatched Client Trust:
• Consistently earns 5-star ratings for her reliability, dedication, and ability to deliver outstanding outcomes.

Jen's modern yet approachable style reflects her belief that real estate is more than just transactions—it's about building lasting relationships and helping clients achieve milestones that matter. Whether guiding families to their dream homes, advising property investors, or securing the best returns on luxury estates, Jen's meticulous approach and innovative strategies ensure exceptional results every time.

Explore a new standard of real estate with Jen Lee—where your property aspirations meet purpose, luxury, and excellence.`
    },
    {
      id: 'claudia',
      name: 'Claudia Faith Chua',
      title: 'Advisor',
      modalTitle: 'Asset Progression Strategist | Dedicated Real Estate Professional',
      photo: claudiaPhoto,
      hasModal: true,
      description: `Claudia believes real estate isn't just about properties — it's about people, plans, and possibilities. As an Asset Progression Strategist, she works closely with clients to understand their goals and life stage, offering clear guidance through every step of the property journey.

Backed by a close-knit team at JSProperty, Claudia ensures every client receives the best possible outcome. With access to advanced market tools and a comprehensive internal database, she delivers timely research, property insights, and tailored strategies, all with care and attention to detail.

If you're looking for someone who listens carefully, acts strategically, and stays committed from start to finish, Claudia is that trusted partner. Whether you're right-sizing, upgrading, or unlocking long-term asset value, she provides the clarity and groundwork to help you make smart, confident decisions.

"It's not just about making property moves — it's about making life moves, wisely."
`
    }
  ];

  const handleReadMore = (member) => {
    if (member.hasModal) {
      setSelectedProfile(member);
    } else {
      // Navigate to home page and scroll to WhoWeAre section (which includes founders)
      window.location.href = '/#who-we-are';
    }
  };

  const closeModal = () => {
    setSelectedProfile(null);
  };

  return (
    <section className='our-team-container'>
      <div className='our-team-header'>
        <h1>Our Team</h1>
        <div className='our-team-description'>
          <p>
            At JSProperty, our Property Advisors go beyond closing deals - we focus on your goals,
            needs, and peace of mind. Backed by deep market knowledge and proven strategies, we help
            homeowners unlock the best value for their property while ensuring a smooth, transparent
            journey from start to finish.
          </p>
          <p className='our-team-tagline'>
            Where Visionaries Find Their Space
          </p>
        </div>
      </div>

      <div className='team-grid'>
        {teamMembers.map((member) => (
          <div key={member.id} className='team-member-card'>
            <div className='team-member-photo-container'>
              {member.photo ? (
                <img src={member.photo} alt={member.name} className='team-member-photo' />
              ) : (
                <div className='team-member-photo-placeholder'>
                  <span>{member.name.split(' ').map(n => n[0]).join('')}</span>
                </div>
              )}
            </div>
            <h3 className='team-member-name'>{member.name}</h3>
            <p className='team-member-title'>{member.title}</p>
            <button
              className='read-more-button'
              onClick={() => handleReadMore(member)}
            >
              Read More
            </button>
          </div>
        ))}
      </div>

      {selectedProfile && (
        <ProfileModal
          profile={selectedProfile}
          onClose={closeModal}
        />
      )}
    </section>
  );
}

export default OurTeam;
